import type { I_apiGetDeps, I_apiGetDeps_Return } from "./apiGetDeps.types";

import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

const apiGetDeps: I_apiGetDeps = async (token: string) => {
    const fetchData = await axios.post<I_apiGetDeps_Return>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/calc/deps/?token=${token}`,
        {
            token,
        },
    );
    return fetchData.data;
};

export default apiGetDeps;
